import React, { useCallback, useEffect, useRef, useState } from "react";
import CommonLayout from "../../../Components/CommonLayout/CommonLayout";
import styles from "../Users/users.module.css";

import GridTable from "../../../Components/CommonTable/GridTable/GridTable";
import Filters from "../../../Components/Common/Filters/Filters";
import { useFetchAll } from "../../../custom/FetchApiHook";
import { UsersApi } from "../../../App/api/users.api";
import filters, { DeliveryManColumns, searchBy } from "./Filters";
import { DeliveryManApis } from "../../../App/api/delivery.apis";
import DeliveryManGridTable from "../../../Components/CommonTable/GridTable/DeliveryManGridTable";
import BasicTable from "../../../Components/CommonTable/BasicTable/BasicTable";
import DeliverymanDetails from "./DeliverymanDetails";

const Drivers = ({ meta }) => {
  const [toggleUsers, SetToggleUser] = useState("");
  const [gridToggle, SetGridToggle] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [toggleUsersDetails, setToggleUsersDetails] = useState(false);
  const type = "drivers";
  const debounceTimeout = useRef();
  const [search, setSearch] = useState("");
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    sortOrder: "desc",
    filter: "",
  });

  const { value, fetchAllData } = useFetchAll(() =>
    DeliveryManApis.getAllDeliveryMan(pagination)
  );
  console.log("Deliveryman All:", value?.data);

useEffect(() => {
  setPagination({
    page: 1,
    limit: 10,
    sortOrder: "desc",
    filter: toggleUsers === "" ? "" : { "availability.status": toggleUsers  },
  });
}, [toggleUsers]);


  

  const onPaginatorClick = (e) => {
          if (e) {
            // console.log("Paginator Clicked",e);
           //  const row={
           //   filters: null,
           //   first: 0,
           //   multiSortMeta: [],
           //   page: 0,
           //   rows: 10,
           //   sortField: null,
           //   sortOrder: null,
           //   totalPages: 2   
           // }
           const data={
            limit:e.rows,
            page:+e.page+1
           }
           handlePagination && handlePagination(data)
           // handlePagination && handlePagination(e.row,limit,sortOrder,filter)
          }
        
        };
  
    const handlePagination=(data)=>{
      // console.log(data);
      
      if (data.clearPagination) {
        setPagination(data.clearPagination)
        return
      }
      
      setPagination((prev)=>{
          let copyfilter={...prev.filter}
          // copyfilter[]
         
          if (data.filter) {
            // console.log("Object.keys[copyfilter]",Object.entries(copyfilter))
            // console.log("Object.keys[copyfilter]",Object.keys(data.filter))
            
            if (copyfilter[Object.keys(data.filter)[0]]) {
              copyfilter[Object.keys(data.filter)[0]]=Object.values(data.filter)[0]
              
            }else{
  
              copyfilter={...data?.filter,...copyfilter}
            }
          
          }
         
    
          return{
            page:data.page?data.page:prev.page,
            limit:data.limit?data.limit:prev.limit,
            sortOrder:data.sortOrder?data.sortOrder:prev.sortOrder,
            filter:copyfilter
          }
    
        })
      }
  
      
   
  
  const handleSearch = useCallback((s) => {
    // console.log('Search at OrderCom', s);
    setSearch(s);
  }, []);

  filters.handleSearch = useCallback(
    (s) => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
      debounceTimeout.current = setTimeout(() => {
        handleSearch(s);
      }, 1500);
    },
    [handleSearch]
  );

  filters.handleClearFilter = () => {
    const clearPagination = {
      page: 1,
      limit: 5,
      sortOrder: "desc",
      filter: {},
    };
    // console.log('clearPagination',clearPagination);
    handlePagination && handlePagination({ clearPagination });
  };
  filters.handleFilter = (name, value) => {
    console.table("name,value", name, value);
    let data = {};
    if (name === "search_by") {
      data.sortOrder = value.code;
    } else {
      const filter = {};
      filter[name] = value.code ? value.code : value;
      data.filter = filter;
    }

    // console.log('data',data);
    handlePagination && handlePagination(data);
  };

  const debouncedSearch = useCallback((s) => {
        if (debounceTimeout.current) {
            clearTimeout(debounceTimeout.current);
        } 
        debounceTimeout.current = setTimeout(() => {
            handleSearch(s); 
        }, 1500);
      }, [handleSearch]);


      
// handle filter 
     const handleFilter=(name,value)=>{
    console.table('name,value',name,value);
    let data={}
    if (name==='search_by') {
      data.sortOrder=value.code
    }
    else{
     
      const filter={}
      filter[`orderDetails.${name}`]=value.code?value.code:value
      data.filter=filter
      
    }
    
    handlePagination && handlePagination(data)
    
    
  }

// handleClearFilter 
   const handleClearFilter=()=>{
    const clearPagination=  {
        "page": 1,
        "limit": 5,
        "sortOrder": "desc",
        "filter": {}
      }
      // console.log('clearPagination',clearPagination);
      handlePagination && handlePagination({clearPagination})
    }

    // handleCellClick
   const handleCellClick =async (cell,field="") => {
        console.log("click on profile:",field);
        setToggleUsersDetails(true)
        console.log("cell", cell);
        console.log("toggleUserDetails:",toggleUsersDetails);
        
        if (field==="_id") {      
          setSelectedData(cell);
          // setIsEarningModal(true)
        }
       
      };

  useEffect(() => {
    fetchAllData();
  }, []);

  useEffect(() => {
    fetchAllData();
  }, [pagination, search]);

  return (
    <div className="p-5">
      <CommonLayout />

      <div style={{ paddingBottom: "4rem" }}>
        {/* <Filters
          SetGridToggle={SetGridToggle}
          gridToggle={gridToggle}
          type={"drivers"}
        /> */}
        <div className={styles.users_toggle_container}>
          <span
            style={{
              color:
                toggleUsers === "" ? "#e34e4e" : "var(--text-color3)",
            }}
            onClick={() => SetToggleUser("")}
          >
            All
          </span>
          <span
            style={{
              color:
                toggleUsers === "offline" ? "#e34e4e" : "var(--text-color3)",
            }}
            onClick={() => SetToggleUser("offline")}
          >
            Offline
          </span>
          <span
            style={{
              color:
                toggleUsers === "busy" ? "#e34e4e" : "var(--text-color3)",
            }}
            onClick={() => SetToggleUser("busy")}
          >
            Busy
          </span>
          <span
            style={{
              color:
                toggleUsers === "available" ? "#e34e4e" : "var(--text-color3)",
            }}
            onClick={() => SetToggleUser("available")}
          >
            Available
          </span>
        </div>

        <div className="m-5">
          <BasicTable
          columns={DeliveryManColumns}
          data={value?.data}
          onPaginatorClick={onPaginatorClick}
          paginatorData={{
            filters: null,
            first: 0,
            multiSortMeta: [],
            page: value?.data?.page || 1,
            rows: value?.data?.limit || 5,
            sortField: null,
            sortOrder: null,
            totalPages: value.data?.totalPages || 1,
            totalCount: value.data?.totalCount || 1,
          }}
          onCellClick={(e) => {
            console.log("Cell Data", e);
          }}
          SearchBy={searchBy}
          handleSearch={debouncedSearch}
          handleFilter={(name, value) => handleFilter(name, value)}
          handleClearFilter={handleClearFilter}
          filters={filters}
          WeekRange={false}
          MonthRange={true}
          // canlenderFilter={canlenderFilter}
          selectedData={selectedData}
          handleCellClick={handleCellClick}
          // handleRowClick={(row) => handleRowClick(row)}
        />
        </div>

        {/* <div style={{ padding: "2rem" }}>
          <DeliveryManGridTable 
          FilterData={filters}
          handlePagination={handlePagination}
          isGrid={gridToggle} 
          SetGridToggle={SetGridToggle} 
          type={"drivers"} 
          value={value}
          />
        </div> */}
      </div>
      {toggleUsersDetails && type === "drivers" && (
                  <DeliverymanDetails
                    data={selectedData}
                    setModal={setToggleUsersDetails}
                    modal={toggleUsersDetails}
                  />
                )}
    </div>
  );
};

export default Drivers;
